@if (loading()) {
  <lib-skeleton-card-generic></lib-skeleton-card-generic>
} @else {
  @if (expiredCompanyDocuments(); as documents) {
    @if (documents.length > 0) {
      <ion-accordion value="adminDocs">
        <ion-item
          slot="header"
          color="warning"
        >
          <ion-label>
            {{ 'company.company_docs' | translate }}
            <strong>({{ documents.length }})</strong>
          </ion-label>
        </ion-item>
        <div
          class="ion-margin-bottom"
          slot="content"
        >
          @for (document of documents; track $index) {
            <lib-notice-documentation-card [document]="document"></lib-notice-documentation-card>
          }
        </div>
      </ion-accordion>
    } @else {
      <lib-empty-result
        text="company.documentation_up_to_date"
        icon="sentiment_satisfied_24dp.svg"
        variant="success"
      ></lib-empty-result>
    }
  }
}
